import React from "react";
import { PageLink, KontentRichText } from "../../../types";
import { Cta } from "../../elements/Cta/Cta";
import { CustomRichTextElement } from "../../elements/CustomRichTextElement/CustomRichTextElement";
import { WideEquals } from "../../elements/Equals/equals";
import { SolidHeroProps } from "../../elements/HeroWrapper/Solid";
import * as styles from "./SimpleHero.module.css";

interface Props {
  title: string;
  text?: KontentRichText;
  cta?: PageLink;
  style?: SolidHeroProps["style"];
  id?: string;
}

export const SimpleHeroContent: React.FC<Props> = ({
  title,
  text,
  cta,
  style,
}) => {
  const includesText = text && text.value !== "<p><br></p>";
  return (
    <div className={styles.simplehero}>
      <div className={styles.content}>
        <h1
          data-kontent-element-codename="title"
          className={includesText ? undefined : styles.large}
        >
          {title}
        </h1>
        {includesText && (
          <div data-kontent-element-codename="text">
            <CustomRichTextElement content={text}></CustomRichTextElement>
          </div>
        )}
        {cta && (
          <Cta
            codename="link_configuration__link"
            href={cta.href}
            label={cta.label}
            target={cta.target}
            invert={style === "light_background"}
          />
        )}
      </div>
    </div>
  );
};
